<template>
  <div class="customer-service t-text" @click="clickHandler" data-qe-id="customer-service-panel">
    <div class="testimonial"></div>
    <t-text class="content" v-html="md(text)"></t-text>
  </div>
</template>

<script setup lang="ts">
import { marked } from 'marked'

/*
 * pass a text from a translation result - it can contain markdown syntax
 */
defineProps<{ text: string }>()
const emit = defineEmits(['customer'])

function md(text: string) {
  return marked(text)
}
function clickHandler(e: Event) {
  const event: any = e

  if (event.target && event.target.tagName === 'A') {
    if (event.target.href && /#customer/.test(event.target.href)) {
      emit('customer')
    }
  }
  e.preventDefault()
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
.customer-service {
  position: relative;
  margin: 6rem auto 0;
  border: 1px solid @c0-d;
  border-radius: 3px;
  padding: 2em;
  background: @c0-a;
  text-align: left;
  .content {
    padding-right: 17em;
    &::v-deep {
      // overwriting default margin could make problems for other content :/
      h2 {
        font-size: 1.25em;
        line-height: 1.25em;
        margin-bottom: 0.8em;
        margin-top: 0;
      }
      p {
        margin: 0.25em 0;
      }
    }
  }
  .testimonial {
    position: absolute;
    bottom: -2em;
    right: 1.625em;
    width: 14.75em;
    height: 14.6875em;
    background: url('../assets/results/customer_service.png') left top no-repeat;
    background-size: contain;
  }
}
</style>
